import { useQueryClient } from 'react-query';

import { useStudyBuilderState } from '../StudyBuilderState';

import { useStudyTeamsUpdater } from './useStudyTeamsUpdater';

export const useCompleteSelectTeamsStep = () => {
  const state = useStudyBuilderState();
  const studyTeamsUpdater = useStudyTeamsUpdater(state.studyRef);
  const queryClient = useQueryClient();

  const complete = async () => {
    state.update({ updatingStudy: true });
    return studyTeamsUpdater.update(state.studyTeams).then(() => {
      state.update({ updatingStudy: false });
      queryClient.invalidateQueries(['GET_PUBLIC_STUDY', state.studyRef]);
    });
  };

  return complete;
};
